
const productUnits = {
  quantity: "تعداد",
  kilogram: "کیلوگرم",
  liter: "لیتر",
  milliLiter: "میلی لیتر",
  gram: "گرم",
  ton: "تُن",
  cc: "سی سی",
  meter: "متر",
  squareMeter: "متر مربع",
  cubicMeter: "متر مکعب",
  feet: "فوت",
  inche: "اینچ",
  squareInche: "اینچ مربع",
  squareFeet: "فوت مربع",
  dozen: "جین",
  hour: " ساعت",
  minute: " دقیقه"
}

export default productUnits